export default __webpack_public_path__ + "static/media/guide31.b1a666b9.png";